import { Role, UserType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { minStringMessage, requiredEmail, requiredEnum } from '@/utils/zodUtils';
import { passwordMinLengthValidation } from '@/utils/zodValidation/passwordMinLengthValidation';

const PASSWORD_MIN_LENGTH = 6;

export const AddFormUserSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      username: requiredEmail(t),
      password: z.string().optional(),
      userType: requiredEnum(UserType, t),
      userRole: requiredEnum(Role, t),
    })
    .strict()
    .refine((data) => passwordMinLengthValidation(data.password, PASSWORD_MIN_LENGTH), {
      ...minStringMessage,
      path: ['password'],
    });

export type AddFormUserType = z.infer<ReturnType<typeof AddFormUserSchema>>;
